"use strict";

CompanyPublicationCertifyDocCtrl.$inject = [
  "$scope",
  "$state",
  "$stateParams",
  "$translate",
  "growl",
  "CompanyPublicationService"
];

function CompanyPublicationCertifyDocCtrl(
  $scope,
  $state,
  $stateParams,
  $translate,
  growl,
  CompanyPublicationService
) {
  $scope.certify = {
    password: '',
    sign: ''
  };
  $scope.saveCertifyDoc = function(){
    CompanyPublicationService.updateCertifyDoc({
      companyId:     $stateParams.companyId,
      publicationId: $stateParams.publicationId
    }, $scope.certify).$promise.then(function(res) {
      growl.addSuccessMessage($translate.instant('publication.save-certificate-document-success'));
      if (!$scope.$parent.$parent.publication.extra.flowCertificates){
        $scope.$parent.$parent.publication.extra.flowCertificates = [{flowId: res.flowId, signDone : false, certificates:[]}];
      }
        var currentFlowCertificates = $scope.$parent.$parent.publication.extra.flowCertificates.filter(function(item){
          return item.signDone === false;
        });
        $scope.$parent.$parent.publication.extra.flowCertificates[
            $scope.$parent.$parent.publication.extra.flowCertificates.indexOf(currentFlowCertificates[0])
        ].certificates.push(res.certificate);
        if (res.certificate.signDone){
            $scope.$parent.$parent.publication.extra.flowCertificates[
                $scope.$parent.$parent.publication.extra.flowCertificates.indexOf(currentFlowCertificates[0])
            ].signDone = true;
        }

    }, function(err) {
      if(err.status === 400){
        growl.addErrorMessage(err.data);
      }else{
        growl.addErrorMessage($translate.instant('publication.save-certificate-document-failure'));
      }
    });
  };

  $scope.hide = function() {
    $scope.$hide();
  };
}

angular.module("dokiv")
  .controller("CompanyPublicationCertifyDocCtrl", CompanyPublicationCertifyDocCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationCertifyDocCtrl.js
// module id = 372
// module chunks = 0